import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Flex,
  CButton,
  CTable,
  CLink,
  Caption,
} from '@appcues/component-library';
import { IconWithinCButton } from 'next/components/ui';

import Panel from 'components/Common/Panel';
import TranslationManager from 'components/StepSettings/Localization/TranslationManager';
import PreviewManager from 'components/StepSettings/Localization/PreviewManager';
import DownloadManager from 'components/StepSettings/Localization/DownloadManager';

export const LocalizationPanel = ({ flowId, locales }) => {
  const sortedLocales = useMemo(
    () => Object.values(locales).sort((a, b) => (a.name < b.name ? -1 : 1)),
    [locales]
  );

  return (
    <Panel name="Localization">
      <Caption>
        Add languages to support, then download the flow content and upload
        translations. &nbsp;
        <CLink
          href="https://docs.appcues.com/article/584-localizing-content"
          isExternal
        >
          How does localization work?
        </CLink>
      </Caption>
      <Flex alignItems="center" justifyContent="space-between" marginY="1em">
        <DownloadManager flowId={flowId} />
        <CLink href="/settings/localization">
          <CButton>
            <IconWithinCButton icon="cog" gray />
            Configure languages
          </CButton>
        </CLink>
      </Flex>
      <CTable
        marginTop={10}
        panel
        data={sortedLocales}
        columns={[
          {
            Header: 'Language',
            accessor: it => it.name,
            Cell: ({ name }) => name,
          },
          {
            Header: 'Translation file',
            Cell: function TranslationCell({ id }) {
              return (
                <TranslationManager flowId={flowId} localeId={id} key={id} />
              );
            },
          },
          {
            Header: 'Flow preview',
            Cell: function PreviewCell({ id, name }) {
              return (
                <PreviewManager
                  language={name}
                  flowId={flowId}
                  localeId={id}
                  key={id}
                />
              );
            },
          },
        ]}
      />
    </Panel>
  );
};

LocalizationPanel.propTypes = {
  flowId: PropTypes.string.isRequired,
  locales: PropTypes.objectOf(PropTypes.string),
};

export default LocalizationPanel;
